export const webClientId = '42312458435-ajb2lhbnct2hjh8p0mm2a2uj2j9ijpj1.apps.googleusercontent.com'